import http from './conn';

class StrokeSizesService {
  get() {
    return http.get('/strokeSize');
  }
}

export default new StrokeSizesService();
